import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import { withNamespaces } from "react-i18next";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  FileCheck,
  LockKeyholeOpen,
  CreditCard,
  ServerCog,
  DoorOpen,
} from "lucide-react";

import AppRentalHeader from "../containers/AppRentalHeader";
import { postSale, putUpdateSale } from "../actions/qrsrental";
import { postRedsysGetParams, fetchCustomer, fetchQrByToken } from "../actions/qrs";
import { currencySymbol } from '../utils/currency';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TICKET_KEY = 'vacway_rental_ticket';

class TicketRentalView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      date: new Date().toLocaleString(),
      accessCode: "",
      forwardScreen: false,
      downloadingPDF: false,
      descriptionZone: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      qrToken: null,
      lockerMatricula: null,
      lockerCustomer: null,
      qrType: null,
      qrMode: null,
      lockerInvoice: null,
      language: null,
      startDate: null,
      endDate: null,
      customerName: null,
      mail: null,
      phoneNumber: null,
      pinAssigned: [],
      Ds_MerchantCode: null,
      Ds_MerchantName: "VACWAY TECH",
      Ds_Url: "https://vacway.com",
      Ds_AuthorisationCode: null,
      Ds_Date: null,
      Ds_Hour: null,
      Ds_Amount: null,
      doorAccess: 0,
      customerSocialName: null,
      customerInvoiceTaxId: null,
      customerInvoiceAddress: null,
    };

    this.generatePDF = this.generatePDF.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    const searchParams = new URLSearchParams(this.props.location.search);
    const lockerPrice      = searchParams.get("lockerPrice");
    const zoneSelected     = searchParams.get("zoneSelected");
    const descriptionZone  = searchParams.get("descriptionZone");
    const selectedLocker   = searchParams.get("selectedLocker");
    const lockerAssigned   = searchParams.get("lockerAssigned");
    const prerentCode      = searchParams.get("prerentCode");
    const qrToken          = searchParams.get("qrToken");
    const lockerMatricula  = searchParams.get("lockerMatricula");
    const lockerCustomer   = searchParams.get("lockerCustomer");
    const qrType           = searchParams.get("qrType");
    const language         = searchParams.get("language");
    const qrMode           = searchParams.get("qrMode");
    const startDate        = searchParams.get("startDate");
    const endDate          = searchParams.get("endDate");
    const customerName     = decodeURIComponent(searchParams.get("customerName") || "");
    const mail             = searchParams.get("mail");
    const phoneNumber      = searchParams.get("phoneNumber");
    const idNumber         = searchParams.get("idNumber") || '';
    const paymentId        = searchParams.get("paymentId");
    const dsSignatureVersion    = searchParams.get("Ds_SignatureVersion");
    const dsMerchantParameters  = searchParams.get("Ds_MerchantParameters");
    const dsSignature           = searchParams.get("Ds_Signature");
    // Addon Payments landings carry the receipt data as plain params —
    // already validated server-side by qrs/gp-response before redirecting here.
    const gpAuthCode       = searchParams.get("gpAuthCode");
    const customerId       = searchParams.get("customerId");

    if (qrToken) {
      this.props.fetchQrByToken(qrToken);
    }

    this.props.i18n.changeLanguage(language);

    // ── Reload guard: restore from sessionStorage if ticket already processed ──
    const savedTicket = (() => {
      try { return JSON.parse(sessionStorage.getItem(TICKET_KEY)); } catch { return null; }
    })();

    if (savedTicket && savedTicket.prerentCode === prerentCode) {
      this.setState({
        lockerPrice:      lockerPrice || 0,
        descriptionZone,
        zoneSelected,
        selectedLocker,
        lockerAssigned,
        qrToken,
        lockerMatricula,
        lockerCustomer,
        qrType,
        qrMode,
        lockerInvoice:    prerentCode,
        language,
        startDate,
        endDate,
        customerName,
        mail,
        phoneNumber,
        pinAssigned:      savedTicket.pinAssigned || [],
        doorAccess:       savedTicket.doorAccess  || 0,
        Ds_AuthorisationCode: savedTicket.Ds_AuthorisationCode || null,
        Ds_MerchantCode:      savedTicket.Ds_MerchantCode      || null,
        Ds_MerchantName:      savedTicket.Ds_MerchantName      || "VACWAY TECH",
        Ds_Date:              savedTicket.Ds_Date               || null,
        Ds_Hour:              savedTicket.Ds_Hour               || null,
        Ds_Amount:            savedTicket.Ds_Amount             || null,
        customerSocialName:       savedTicket.customerSocialName       || null,
        customerInvoiceTaxId:     savedTicket.customerInvoiceTaxId     || null,
        customerInvoiceAddress:   savedTicket.customerInvoiceAddress   || null,
        date: new Date().toLocaleString(),
      }, () => this.TotalComponent());

      // Still fetch customer data for PDF (read-only, safe to repeat)
      if (customerId) {
        this.props.fetchCustomer(customerId)
          .then(customer => {
            if (customer?.response) {
              this.setState({
                customerSocialName:     customer.response.Social_name     || "VACWAY TECH S.L.",
                customerInvoiceTaxId:   customer.response.Invoice_taxid   || "N/A",
                customerInvoiceAddress: customer.response.Invoice_address  || "N/A",
                // Redsys never returns the merchant name (only the FUC), so it
                // comes from the customer record that owns the Redsys config.
                Ds_MerchantName:        customer.response.Social_name || customer.response.Fullname || "VACWAY TECH",
              });
            }
          })
          .catch(console.error);
      }
      return;
    }

    // ── First-time: block on page reload ──
    const navigationEntries = window.performance.getEntriesByType("navigation");
    if (navigationEntries.length > 0 && navigationEntries[0].type === "reload") {
      console.log("Page was reloaded");
      return;
    }

    this.setState(
      {
        lockerPrice:    lockerPrice || 0,
        descriptionZone,
        zoneSelected,
        selectedLocker,
        lockerAssigned,
        qrToken,
        lockerMatricula,
        lockerCustomer,
        qrType,
        qrMode,
        lockerInvoice:  prerentCode,
        language,
        startDate,
        endDate,
        customerName,
        mail,
        phoneNumber,
      },
      () => {
        // Seconds from QR scan (timer set in HomeView) to this ticket view —
        // same OperationTime metric the machine app reports.
        const opStart = Number(sessionStorage.getItem("vacway_op_start"));

        const saleData = {
          PrerentCode:    this.state.lockerInvoice,
          CustomerName:   this.state.customerName,
          CustomerEmail:  this.state.mail,
          CustomerPhone:  this.state.phoneNumber,
          IdNumber:       idNumber,
          EmailLanguage:  this.state.language === "en" ? "gb" : "es",
          SendEmail:      true,
          SaleQR:         this.state.qrToken,
          auth_code:      null,
          payment_id:     paymentId,
          order_id:       null,
          merchant_id:    null,
          payment_date:   null,
          payment_time:   null,
          OperationTime:  opStart > 0 ? Math.round((Date.now() - opStart) / 1000) : 0,
        };

        const paramsRedsys = {
          Ds_SignatureVersion:    dsSignatureVersion,
          Ds_MerchantParameters:  dsMerchantParameters,
          Ds_Signature:           dsSignature,
          parameterToFetch:       "all",
          secretKey:              null,
        };

        this.props
          .postSale(saleData)
          .then((answer) => {
            const today      = new Date().toLocaleString();
            const pinAssigned = answer.response.PinAssigned || [];
            const doorCode    = answer.response.DoorAccess ?? answer.response.doorAccess ?? 0;

            this.setState({ date: today, pinAssigned, doorAccess: doorCode });
            this.TotalComponent();

            return this.props.fetchCustomer(customerId);
          })
          .then((customer) => {
            if (!customer?.response?.Redsys) {
              throw new Error("Invalid customer response or missing Redsys data");
            }

            paramsRedsys.secretKey = customer.response.Redsys.SECRETKEY;

            this.setState({
              customerSocialName:     customer.response.Social_name     || "VACWAY TECH S.L.",
              customerInvoiceTaxId:   customer.response.Invoice_taxid   || "N/A",
              customerInvoiceAddress: customer.response.Invoice_address  || "N/A",
              // Redsys never returns the merchant name (only the FUC), so it
              // comes from the customer record that owns the Redsys config.
              Ds_MerchantName:        customer.response.Social_name || customer.response.Fullname || "VACWAY TECH",
            });

            // Addon Payments: the auth code came as a plain param, no Redsys
            // decode needed — feed it through the same update path.
            if (gpAuthCode) {
              return {
                response: {
                  decodedParams: {
                    Ds_AuthorisationCode: gpAuthCode,
                    Ds_Order: paymentId,
                  },
                },
              };
            }

            return this.props.postRedsysGetParams(paramsRedsys);
          })
          .then((answer) => {
            console.log("RedsysResponse:", answer);

            const saleUpdateDate = {
              auth_code:    answer.response.decodedParams?.Ds_AuthorisationCode || "N/A",
              order_id:     answer.response.decodedParams?.Ds_Order             || "N/A",
              merchant_id:  answer.response.decodedParams?.Ds_MerchantCode      || "N/A",
              payment_date: answer.response.decodedParams?.Ds_Date              || new Date().toLocaleDateString(),
              payment_time: answer.response.decodedParams?.Ds_Hour              || new Date().toLocaleTimeString(),
            };

            this.props.putUpdateSale(prerentCode, saleUpdateDate);

            this.setState({
              Ds_AuthorisationCode: saleUpdateDate.auth_code,
              Ds_MerchantCode:      saleUpdateDate.merchant_id,
              Ds_Date:              saleUpdateDate.payment_date,
              Ds_Hour:              saleUpdateDate.payment_time,
              Ds_Amount:            answer.response.decodedParams?.Ds_Amount || null,
            }, () => {
              // Persist to sessionStorage so reload restores the ticket without API calls
              try {
                const s = this.state;
                sessionStorage.setItem(TICKET_KEY, JSON.stringify({
                  prerentCode,
                  pinAssigned:           s.pinAssigned,
                  doorAccess:            s.doorAccess,
                  Ds_AuthorisationCode:  s.Ds_AuthorisationCode,
                  Ds_MerchantCode:       s.Ds_MerchantCode,
                  Ds_MerchantName:       s.Ds_MerchantName,
                  Ds_Date:               s.Ds_Date,
                  Ds_Hour:               s.Ds_Hour,
                  Ds_Amount:             s.Ds_Amount,
                  customerSocialName:    s.customerSocialName,
                  customerInvoiceTaxId:  s.customerInvoiceTaxId,
                  customerInvoiceAddress: s.customerInvoiceAddress,
                }));
              } catch { /* ignore */ }
            });
          })
          .catch((error) => {
            console.error("An error occurred:", error);
            this.TotalComponent();
          });
      }
    );
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    sessionStorage.removeItem(TICKET_KEY);
  }

  handleBeforeUnload = (event) => {
    // Set the returnValue property of the event to show the alert message
    event.preventDefault();
  };

  getImageDataURL = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const image = new Image();

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      image.onerror = (error) => {
        reject(error);
      };

      image.src = imageUrl;
    });
  };

  TotalComponent() {
    const { iva, lockerPrice } = this.state;

    let importeBase = (lockerPrice / (1 + iva / 100)).toFixed(2);
    let importeIva = (lockerPrice - importeBase).toFixed(2);
    let total = Number(lockerPrice).toFixed(2);

    this.setState({
      importeBase: importeBase,
      importeIva: importeIva,
      total: total,
    });

    return { total, importeBase, importeIva, iva };
  }

  getLockerType(type) {
    const { t, i18n } = this.props;

    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large";
      case "CNXL":
        return "Large Carga";
      case "BWXL":
        return "Large XL";
      case "CWXL":
        return "Large Carga XL";
      case "BN2XL":
        return "Large";
      case "CN2XL":
        return "Large Carga";
      case "BW2XL":
        return "Large XL";
      case "CW2XL":
        return "Large Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "BW3XL":
        return "Ski Carga XL";
      default:
        return "None";
    }
  }

  render() {
    const { t } = this.props;
    const {
      iva, importeBase, importeIva, total, downloadingPDF,
      zoneSelected, selectedLocker, lockerAssigned, lockerInvoice, descriptionZone,
      qrToken, startDate, endDate, pinAssigned,
      Ds_MerchantCode, Ds_MerchantName, Ds_Url, Ds_AuthorisationCode, Ds_Date, Ds_Hour, Ds_Amount,
      doorAccess,
    } = this.state;

    if (!lockerAssigned) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    const parseDate = (ds) => { const [d, m, y] = ds.split('/'); return new Date(y, m - 1, d); };
    const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    const isStartDateToday = startDate && fmt(parseDate(startDate)) === fmt(new Date());
    const lockerList = lockerAssigned.split(',').filter(Boolean);

    const renderCodeList = () => (
      <div className="nm-ticket-code-list">
        {lockerList.map((num, i) => (
          <div key={i} className="nm-ticket-code-row">
            <div className="nm-ticket-code-item">
              <span className="nm-ticket-code-label">{t('Nº TAQUILLA')}</span>
              <span className="nm-ticket-code-value">{num.trim()}</span>
            </div>
            {isStartDateToday && pinAssigned[i] && (
              <>
                <div className="nm-ticket-code-sep" />
                <div className="nm-ticket-code-item">
                  <span className="nm-ticket-code-label">{t('PIN')}</span>
                  <span className="nm-ticket-code-value">{pinAssigned[i]}</span>
                </div>
              </>
            )}
          </div>
        ))}
        {!isStartDateToday && (
          <p style={{ textAlign: 'center', fontSize: '0.82rem', color: '#6b7280', margin: '8px 0 0' }}>
            {t('El PIN se enviará al email el día de inicio de tu reserva')}
          </p>
        )}
        {isStartDateToday && pinAssigned.length === 0 && (
          <p style={{ textAlign: 'center', fontSize: '0.82rem', color: '#6b7280', margin: '8px 0 0' }}>
            {t('El PIN se ha enviado a tu email')}
          </p>
        )}
      </div>
    );

    const renderSummary = () => (
      <div className="nm-form">
        <div className="nm-ticket-card-header">
          <div className="nm-page-header-card-text">
            <h3>{t('Resumen de reserva')}</h3>
          </div>
          <FileCheck className="nm-form-icon" strokeWidth={1} />
        </div>
        <div className="nm-pay-fields">
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Código de reserva')}</span>
            <span className="nm-pay-field-value">{lockerInvoice}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Zona')}</span>
            <span className="nm-pay-field-value">{zoneSelected} — {descriptionZone}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Inicio')}</span>
            <span className="nm-pay-field-value">{startDate}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Fin')}</span>
            <span className="nm-pay-field-value">{endDate}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Hora Límite')}</span>
            <span className="nm-pay-field-value">23:59</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Taquilla')}</span>
            <span className="nm-pay-field-value">{this.getLockerType(selectedLocker)}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Cantidad')}</span>
            <span className="nm-pay-field-value">{lockerList.length}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Base')}</span>
            <span className="nm-pay-field-value">{importeBase} {currencySymbol()}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('IVA')} ({iva}%)</span>
            <span className="nm-pay-field-value">{importeIva} {currencySymbol()}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t('Total')}</span>
            <span className="nm-pay-field-value" style={{ fontWeight: 800 }}>{total} {currencySymbol()}</span>
          </div>
          {Ds_AuthorisationCode && Ds_AuthorisationCode !== 'N/A' && (
            <>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t('FUC del comercio')}</span>
                <span className="nm-pay-field-value" style={{ fontSize: '0.78rem' }}>{Ds_MerchantCode}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t('Nombre del comercio')}</span>
                <span className="nm-pay-field-value">{Ds_MerchantName}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t('URL del comercio')}</span>
                <span className="nm-pay-field-value" style={{ fontSize: '0.78rem' }}>{Ds_Url}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t('Importe de la operación')}</span>
                <span className="nm-pay-field-value">{Ds_Amount ? (Number(Ds_Amount) / 100).toFixed(2) : total} {currencySymbol()}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t('Código de autorización')}</span>
                <span className="nm-pay-field-value" style={{ fontSize: '0.78rem' }}>{Ds_AuthorisationCode}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t('Fecha / hora de la operación')}</span>
                <span className="nm-pay-field-value" style={{ fontSize: '0.78rem' }}>{Ds_Hour} {Ds_Date}</span>
              </div>
            </>
          )}
        </div>
      </div>
    );

    const renderInstructions = () => (
      <div className="nm-form nm-ticket-instructions">
        <div className="nm-ticket-card-header">
          <div className="nm-page-header-card-text">
            <h3>{t('Instrucciones')}</h3>
          </div>
          <ServerCog className="nm-form-icon" strokeWidth={1} />
        </div>
        {[
          { step: 1, img: '/images/lockerBasicClosedStep1.svg', text: t('LOCALIZA TU TAQUILLA') },
          { step: 2, img: '/images/lockerBasicClosedStep2.svg', text: t('TOCA EL TECLADO') },
          { step: 3, img: '/images/lockerBasicClosedStep3.svg', text: t('INTRODUCE TU PIN') },
          { step: 4, img: '/images/lockerBasicOpenedStep4.svg', text: t('ABRE LAS VECES QUE QUIERAS') },
        ].map(({ step, img, text }) => (
          <div key={step} className="nm-ticket-step">
            <div className="nm-ticket-step-num">{step}</div>
            <img src={img} alt={`Paso ${step}`} className="nm-ticket-step-img" />
            <div className="nm-ticket-step-body">
              <span className="nm-ticket-step-label">{t(`PASO ${step}`)}</span>
              <span className="nm-ticket-step-text">{text}</span>
            </div>
          </div>
        ))}
      </div>
    );

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <div className="nm-page">

          {/* Success banner */}
          <div className="nm-ticket-success-banner">
            <div className="nm-ticket-success-text">
              <h3>{t('¡GRACIAS POR RESERVAR TU TAQUILLA!')}</h3>
              <p>{t('Sigue las instrucciones que encontrarás a continuación o en tu email.')}</p>
            </div>
            <img className="nm-ticket-confetti" src="/images/animated-icons/firecracker.gif" alt="finish" />
          </div>

          {/* Locker codes */}
          <div className="nm-form nm-ticket-access-card">
            <div className="nm-ticket-card-header">
              <div className="nm-page-header-card-text">
                <h3>{t('Información de taquilla')}</h3>
              </div>
              <LockKeyholeOpen className="nm-form-icon" strokeWidth={1} />
            </div>
            {renderCodeList()}
          </div>

          {/* Door access */}
          {doorAccess != 0 && doorAccess !== '' && (
            <div className="nm-form nm-ticket-door-card">
              <div className="nm-ticket-card-header">
                <div className="nm-page-header-card-text">
                  <h3>{t('ACCESO A LOCAL')}</h3>
                </div>
                <DoorOpen className="nm-form-icon" strokeWidth={1} />
              </div>
              <div className="nm-ticket-code-list">
                <div className="nm-ticket-code-row">
                  <div className="nm-ticket-code-item">
                    <span className="nm-ticket-code-label">{t('Código')}</span>
                    <span className="nm-ticket-code-value">{doorAccess}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Responsive 2-column on desktop, stacked on mobile */}
          <div className="nm-ticket-pc-grid">
            <div className="nm-ticket-pc-col-left">
              {renderSummary()}
            </div>
            <div className="nm-ticket-pc-col-right">
              {renderInstructions()}
            </div>
          </div>

        </div>

        {/* Bottom action bar (replaces step bar) */}
        <div className="rm-ticket-action-bar">
          {downloadingPDF ? (
            <span className="nm-btn-spinner" />
          ) : (
            <button className="rm-ticket-action-btn rm-ticket-action-btn-download" onClick={this.generatePDF}>
              ⬇ {t('DESCARGAR TICKET')}
            </button>
          )}
          <button
            className="rm-ticket-action-btn rm-ticket-action-btn-new"
            onClick={() => history.push(`/qrsale/${qrToken}`)}
          >
            + {t('Alquilar otra taquilla')}
          </button>
        </div>
      </div>
    );
  }

  generatePDF = async () => {
    const {
      iva,
      importeBase,
      importeIva,
      total,
      date,
      accessCode,
      zoneSelected,
      selectedLocker,
      lockerCustomer,
      lockerMatricula,
      lockerAssigned,
      lockerInvoice,
      descriptionZone,
      lockerSelected,
      startDate,
      endDate,
      customerSocialName,
      customerInvoiceTaxId,
      customerInvoiceAddress,
      Ds_AuthorisationCode,
      Ds_Date,
      Ds_Hour,
      Ds_Amount,
      Ds_MerchantCode,
      Ds_MerchantName,
      Ds_Url,
    } = this.state;

    const qrMode = 0; //HARDCODED

    const { t, i18n } = this.props;

    this.setState({ downloadingPDF: true });

    // Redsys payment authorisation block — only rendered for real card payments.
    // Matches the invoice's existing billing-title / billing-details styling.
    // ('N/A' is the fallback set for free reservations, so exclude it.)
    const importeOperacion = Ds_Amount ? (Number(Ds_Amount) / 100).toFixed(2) : total;
    const paymentInfo = (Ds_AuthorisationCode && Ds_AuthorisationCode !== "N/A")
      ? [
          "\n",
          { text: `${t("INFORMACIÓN DE PAGO:")}`, style: "invoiceBillingTitle" },
          {
            text: `${t("FUC del comercio")}: ${Ds_MerchantCode}\n ${t("Nombre del comercio")}: ${Ds_MerchantName}\n ${t("URL del comercio")}: ${Ds_Url}\n ${t("Importe de la operación")}: ${importeOperacion} ${currencySymbol()}\n ${t("Código de autorización")}: ${Ds_AuthorisationCode}\n ${t("Fecha / hora de la operación")}: ${Ds_Date} ${Ds_Hour}`,
            style: "invoiceBillingDetails",
          },
        ]
      : [];

    const logocolorDataURL = await this.getImageDataURL(
      "/images/logocolor.png"
    );

    const step1DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep1.png"
    );
    const step2DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep2.png"
    );
    const step3DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep3.png"
    );
    const step4DataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const step1OTODataURL = await this.getImageDataURL("/images/qr.png");
    const step2OTODataURL = await this.getImageDataURL(
      "/images/lockerOTOStep2.png"
    );
    const step3OTODataURL = await this.getImageDataURL(
      "/images/lockerOpen.png"
    );
    const step4OTODataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const docDefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Reserva")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        "\n\n\n\n",
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: customerSocialName || "VACWAY TECH S.L.",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerAssigned}\n ${t(
                "ZONA"
              )}: ${zoneSelected} - ${descriptionZone} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t("CANTIDAD")}: ${
                lockerAssigned.split(",").length
              } \n ${t("RESERVA")}: ${startDate} - ${endDate}`,
              style: "invoiceBillingDetails",
            },
            {
              text: `${customerInvoiceAddress || "N/A"} \n CIF: ${customerInvoiceTaxId || "N/A"}`,
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemNumber",
                  },
                ],
                {
                  text: `${lockerAssigned.split(",").length}`,
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        ...paymentInfo,
        "\n\n\n\n",
        {
          text: `${t("INSTRUCCIONES DE USO:")}`,
          style: "invoiceBillingTitle",
        },
        "\n\n",
        {
          columns: [
            {
              image: step1DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("PASO 1")}\n${t("LOCALIZA TU TAQUILLA")}`,
            },
            {
              image: step2DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("PASO 2")}\n${t("TOCA EL TECLADO")}`,
            },
          ],
        },
        "\n\n\n\n",
        {
          text: ``,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("PASO 3")}\n${t("INTRODUCE TU PIN")}`,
            },
            {
              image: step4DataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("PASO 4")}\n${t("ABRE LAS VECES QUE QUIERAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [50, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    const docOTODefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: customerSocialName || "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "CÓDIGO DE ACCESO"
              )}: ${accessCode}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(lockerSelected)}\n ${t(
                "ACCESIBLE"
              )}:  \n ${t("UBICACIÓN")}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: `${customerInvoiceAddress || "N/A"} \n CIF: ${customerInvoiceTaxId || "N/A"}`,
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(lockerSelected)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t('APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR')}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("ACCEDE CON TUS CREDENCIALES")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("SELECCIONA ABRIR AHORA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4OTODataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("DISPONES DE 2 APERTURAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download(`VACWAYlockers-${lockerInvoice}.pdf`);
    this.setState({ downloadingPDF: false });
  };
}

const mapStateToProps = (state) => ({
  auth: true,
  salerental: state.salerental,
  booking: state.booking,
  qrData: state.qrs.qr,
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  postSale: bindActionCreators(postSale, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  putUpdateSale: bindActionCreators(putUpdateSale, dispatch),
  fetchQrByToken: bindActionCreators(fetchQrByToken, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(TicketRentalView)
);
